import { FunctionComponent } from "react";

import { ProspectScoreBadge } from "@/components/ProspectScoreBadge/ProspectScoreBadge";
import { ChannelPills } from "@/components/ChannelPills/ChannelPills";

import { CcRecipientInfo } from "@/schemas/cc-recipient";

/**
 * Rich lead chip for a CC'd recipient that resolved to a known prospect
 * (inbox thread v4): priority badge + name + channel-availability pills.
 */
export const CcLeadChip: FunctionComponent<{ recipient: CcRecipientInfo }> = ({ recipient }) => (
	<span
		className="inline-flex items-center gap-1.5 rounded-full border border-border-light bg-white py-0.5 pl-0.5 pr-1 shadow-sm"
		data-testid="cc-lead-chip"
	>
		<ProspectScoreBadge overallScore={recipient.overallScore} size="sm" />
		<span className="text-sm font-semibold text-text">{recipient.name || recipient.email}</span>
		<ChannelPills
			email={recipient.emailStatus}
			linkedin={recipient.linkedinStatus}
			phone={recipient.phoneStatus}
		/>
	</span>
);
